var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDottedBgHero(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 309,
    height: 65,
    viewBox: "0 0 309 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2683_332862)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.54872,
    cy: 4.13344,
    r: 1.54872,
    fill: "url(#paint0_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.54872,
    cy: 13.4254,
    r: 1.54872,
    fill: "url(#paint1_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.54872,
    cy: 22.7179,
    r: 1.54872,
    fill: "url(#paint2_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.54872,
    cy: 32.0104,
    r: 1.54872,
    fill: "url(#paint3_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.54872,
    cy: 41.3029,
    r: 1.54872,
    fill: "url(#paint4_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.54872,
    cy: 50.5949,
    r: 1.54872,
    fill: "url(#paint5_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.54872,
    cy: 59.8873,
    r: 1.54872,
    fill: "url(#paint6_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.8412,
    cy: 4.13344,
    r: 1.54872,
    fill: "url(#paint7_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.8412,
    cy: 13.4254,
    r: 1.54872,
    fill: "url(#paint8_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.8412,
    cy: 22.7179,
    r: 1.54872,
    fill: "url(#paint9_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.8412,
    cy: 32.0104,
    r: 1.54872,
    fill: "url(#paint10_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.8412,
    cy: 41.3029,
    r: 1.54872,
    fill: "url(#paint11_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.8412,
    cy: 50.5949,
    r: 1.54872,
    fill: "url(#paint12_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.8412,
    cy: 59.8873,
    r: 1.54872,
    fill: "url(#paint13_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.1336,
    cy: 4.13344,
    r: 1.54872,
    fill: "url(#paint14_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.1336,
    cy: 13.4254,
    r: 1.54872,
    fill: "url(#paint15_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.1336,
    cy: 22.7179,
    r: 1.54872,
    fill: "url(#paint16_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.1336,
    cy: 32.0104,
    r: 1.54872,
    fill: "url(#paint17_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.1336,
    cy: 41.3029,
    r: 1.54872,
    fill: "url(#paint18_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.1336,
    cy: 50.5949,
    r: 1.54872,
    fill: "url(#paint19_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.1336,
    cy: 59.8873,
    r: 1.54872,
    fill: "url(#paint20_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.4261,
    cy: 4.13344,
    r: 1.54872,
    fill: "url(#paint21_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.4261,
    cy: 13.4254,
    r: 1.54872,
    fill: "url(#paint22_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.4261,
    cy: 22.7179,
    r: 1.54872,
    fill: "url(#paint23_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.4261,
    cy: 32.0104,
    r: 1.54872,
    fill: "url(#paint24_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.4261,
    cy: 41.3029,
    r: 1.54872,
    fill: "url(#paint25_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.4261,
    cy: 50.5949,
    r: 1.54872,
    fill: "url(#paint26_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.4261,
    cy: 59.8873,
    r: 1.54872,
    fill: "url(#paint27_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.7186,
    cy: 4.13344,
    r: 1.54872,
    fill: "url(#paint28_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.7186,
    cy: 13.4254,
    r: 1.54872,
    fill: "url(#paint29_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.7186,
    cy: 22.7179,
    r: 1.54872,
    fill: "url(#paint30_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.7186,
    cy: 32.0104,
    r: 1.54872,
    fill: "url(#paint31_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.7186,
    cy: 41.3029,
    r: 1.54872,
    fill: "url(#paint32_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.7186,
    cy: 50.5949,
    r: 1.54872,
    fill: "url(#paint33_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.7186,
    cy: 59.8873,
    r: 1.54872,
    fill: "url(#paint34_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.0099,
    cy: 4.13344,
    r: 1.54872,
    fill: "url(#paint35_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.0099,
    cy: 13.4254,
    r: 1.54872,
    fill: "url(#paint36_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.0099,
    cy: 22.7179,
    r: 1.54872,
    fill: "url(#paint37_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.0099,
    cy: 32.0104,
    r: 1.54872,
    fill: "url(#paint38_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.0099,
    cy: 41.3029,
    r: 1.54872,
    fill: "url(#paint39_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.0099,
    cy: 50.5949,
    r: 1.54872,
    fill: "url(#paint40_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.0099,
    cy: 59.8873,
    r: 1.54872,
    fill: "url(#paint41_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.3023,
    cy: 4.13344,
    r: 1.54872,
    fill: "url(#paint42_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.3023,
    cy: 13.4254,
    r: 1.54872,
    fill: "url(#paint43_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.3023,
    cy: 22.7179,
    r: 1.54872,
    fill: "url(#paint44_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.3023,
    cy: 32.0104,
    r: 1.54872,
    fill: "url(#paint45_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.3023,
    cy: 41.3029,
    r: 1.54872,
    fill: "url(#paint46_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.3023,
    cy: 50.5949,
    r: 1.54872,
    fill: "url(#paint47_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.3023,
    cy: 59.8873,
    r: 1.54872,
    fill: "url(#paint48_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.5948,
    cy: 4.13344,
    r: 1.54872,
    fill: "url(#paint49_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75.8873,
    cy: 4.13344,
    r: 1.54872,
    fill: "url(#paint50_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85.1797,
    cy: 4.13344,
    r: 1.54872,
    fill: "url(#paint51_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 94.4722,
    cy: 4.13344,
    r: 1.54872,
    fill: "url(#paint52_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 103.765,
    cy: 4.13344,
    r: 1.54872,
    fill: "url(#paint53_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 113.057,
    cy: 4.13344,
    r: 1.54872,
    fill: "url(#paint54_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.5948,
    cy: 13.4254,
    r: 1.54872,
    fill: "url(#paint55_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75.8873,
    cy: 13.4254,
    r: 1.54872,
    fill: "url(#paint56_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85.1797,
    cy: 13.4254,
    r: 1.54872,
    fill: "url(#paint57_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 94.4722,
    cy: 13.4254,
    r: 1.54872,
    fill: "url(#paint58_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 103.765,
    cy: 13.4254,
    r: 1.54872,
    fill: "url(#paint59_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 113.057,
    cy: 13.4254,
    r: 1.54872,
    fill: "url(#paint60_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.5948,
    cy: 22.7179,
    r: 1.54872,
    fill: "url(#paint61_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75.8873,
    cy: 22.7179,
    r: 1.54872,
    fill: "url(#paint62_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85.1797,
    cy: 22.7179,
    r: 1.54872,
    fill: "url(#paint63_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 94.4722,
    cy: 22.7179,
    r: 1.54872,
    fill: "url(#paint64_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 103.765,
    cy: 22.7179,
    r: 1.54872,
    fill: "url(#paint65_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 113.057,
    cy: 22.7179,
    r: 1.54872,
    fill: "url(#paint66_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.5948,
    cy: 32.0104,
    r: 1.54872,
    fill: "url(#paint67_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75.8873,
    cy: 32.0104,
    r: 1.54872,
    fill: "url(#paint68_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85.1797,
    cy: 32.0104,
    r: 1.54872,
    fill: "url(#paint69_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 94.4722,
    cy: 32.0104,
    r: 1.54872,
    fill: "url(#paint70_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 103.765,
    cy: 32.0104,
    r: 1.54872,
    fill: "url(#paint71_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 113.057,
    cy: 32.0104,
    r: 1.54872,
    fill: "url(#paint72_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.5948,
    cy: 41.3029,
    r: 1.54872,
    fill: "url(#paint73_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75.8873,
    cy: 41.3029,
    r: 1.54872,
    fill: "url(#paint74_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85.1797,
    cy: 41.3029,
    r: 1.54872,
    fill: "url(#paint75_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 94.4722,
    cy: 41.3029,
    r: 1.54872,
    fill: "url(#paint76_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 103.765,
    cy: 41.3029,
    r: 1.54872,
    fill: "url(#paint77_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 113.057,
    cy: 41.3029,
    r: 1.54872,
    fill: "url(#paint78_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.5948,
    cy: 50.5949,
    r: 1.54872,
    fill: "url(#paint79_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75.8873,
    cy: 50.5949,
    r: 1.54872,
    fill: "url(#paint80_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85.1797,
    cy: 50.5949,
    r: 1.54872,
    fill: "url(#paint81_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 94.4722,
    cy: 50.5949,
    r: 1.54872,
    fill: "url(#paint82_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 103.765,
    cy: 50.5949,
    r: 1.54872,
    fill: "url(#paint83_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 113.057,
    cy: 50.5949,
    r: 1.54872,
    fill: "url(#paint84_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.5948,
    cy: 59.8873,
    r: 1.54872,
    fill: "url(#paint85_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75.8873,
    cy: 59.8873,
    r: 1.54872,
    fill: "url(#paint86_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85.1797,
    cy: 59.8873,
    r: 1.54872,
    fill: "url(#paint87_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 94.4722,
    cy: 59.8873,
    r: 1.54872,
    fill: "url(#paint88_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 103.765,
    cy: 59.8873,
    r: 1.54872,
    fill: "url(#paint89_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 113.057,
    cy: 59.8873,
    r: 1.54872,
    fill: "url(#paint90_linear_2683_332862)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 122.549,
    cy: 4.13344,
    r: 1.54872,
    fill: "url(#paint91_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 122.549,
    cy: 13.4254,
    r: 1.54872,
    fill: "url(#paint92_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 122.549,
    cy: 22.7179,
    r: 1.54872,
    fill: "url(#paint93_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 122.549,
    cy: 32.0104,
    r: 1.54872,
    fill: "url(#paint94_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 122.549,
    cy: 41.3029,
    r: 1.54872,
    fill: "url(#paint95_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 122.549,
    cy: 50.5949,
    r: 1.54872,
    fill: "url(#paint96_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 122.549,
    cy: 59.8873,
    r: 1.54872,
    fill: "url(#paint97_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 131.841,
    cy: 4.13344,
    r: 1.54872,
    fill: "url(#paint98_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 131.841,
    cy: 13.4254,
    r: 1.54872,
    fill: "url(#paint99_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 131.841,
    cy: 22.7179,
    r: 1.54872,
    fill: "url(#paint100_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 131.841,
    cy: 32.0104,
    r: 1.54872,
    fill: "url(#paint101_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 131.841,
    cy: 41.3029,
    r: 1.54872,
    fill: "url(#paint102_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 131.841,
    cy: 50.5949,
    r: 1.54872,
    fill: "url(#paint103_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 131.841,
    cy: 59.8873,
    r: 1.54872,
    fill: "url(#paint104_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.134,
    cy: 4.13344,
    r: 1.54872,
    fill: "url(#paint105_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.134,
    cy: 13.4254,
    r: 1.54872,
    fill: "url(#paint106_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.134,
    cy: 22.7179,
    r: 1.54872,
    fill: "url(#paint107_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.134,
    cy: 32.0104,
    r: 1.54872,
    fill: "url(#paint108_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.134,
    cy: 41.3029,
    r: 1.54872,
    fill: "url(#paint109_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.134,
    cy: 50.5949,
    r: 1.54872,
    fill: "url(#paint110_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.134,
    cy: 59.8873,
    r: 1.54872,
    fill: "url(#paint111_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150.426,
    cy: 4.13344,
    r: 1.54872,
    fill: "url(#paint112_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150.426,
    cy: 13.4254,
    r: 1.54872,
    fill: "url(#paint113_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150.426,
    cy: 22.7179,
    r: 1.54872,
    fill: "url(#paint114_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150.426,
    cy: 32.0104,
    r: 1.54872,
    fill: "url(#paint115_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150.426,
    cy: 41.3029,
    r: 1.54872,
    fill: "url(#paint116_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150.426,
    cy: 50.5949,
    r: 1.54872,
    fill: "url(#paint117_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150.426,
    cy: 59.8873,
    r: 1.54872,
    fill: "url(#paint118_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 159.719,
    cy: 4.13344,
    r: 1.54872,
    fill: "url(#paint119_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 159.719,
    cy: 13.4254,
    r: 1.54872,
    fill: "url(#paint120_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 159.719,
    cy: 22.7179,
    r: 1.54872,
    fill: "url(#paint121_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 159.719,
    cy: 32.0104,
    r: 1.54872,
    fill: "url(#paint122_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 159.719,
    cy: 41.3029,
    r: 1.54872,
    fill: "url(#paint123_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 159.719,
    cy: 50.5949,
    r: 1.54872,
    fill: "url(#paint124_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 159.719,
    cy: 59.8873,
    r: 1.54872,
    fill: "url(#paint125_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 169.01,
    cy: 4.13344,
    r: 1.54872,
    fill: "url(#paint126_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 169.01,
    cy: 13.4254,
    r: 1.54872,
    fill: "url(#paint127_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 169.01,
    cy: 22.7179,
    r: 1.54872,
    fill: "url(#paint128_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 169.01,
    cy: 32.0104,
    r: 1.54872,
    fill: "url(#paint129_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 169.01,
    cy: 41.3029,
    r: 1.54872,
    fill: "url(#paint130_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 169.01,
    cy: 50.5949,
    r: 1.54872,
    fill: "url(#paint131_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 169.01,
    cy: 59.8873,
    r: 1.54872,
    fill: "url(#paint132_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 178.302,
    cy: 4.13344,
    r: 1.54872,
    fill: "url(#paint133_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 178.302,
    cy: 13.4254,
    r: 1.54872,
    fill: "url(#paint134_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 178.302,
    cy: 22.7179,
    r: 1.54872,
    fill: "url(#paint135_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 178.302,
    cy: 32.0104,
    r: 1.54872,
    fill: "url(#paint136_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 178.302,
    cy: 41.3029,
    r: 1.54872,
    fill: "url(#paint137_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 178.302,
    cy: 50.5949,
    r: 1.54872,
    fill: "url(#paint138_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 178.302,
    cy: 59.8873,
    r: 1.54872,
    fill: "url(#paint139_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 187.595,
    cy: 4.13344,
    r: 1.54872,
    fill: "url(#paint140_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 196.887,
    cy: 4.13344,
    r: 1.54872,
    fill: "url(#paint141_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.18,
    cy: 4.13344,
    r: 1.54872,
    fill: "url(#paint142_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 215.472,
    cy: 4.13344,
    r: 1.54872,
    fill: "url(#paint143_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 224.765,
    cy: 4.13344,
    r: 1.54872,
    fill: "url(#paint144_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.057,
    cy: 4.13344,
    r: 1.54872,
    fill: "url(#paint145_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 187.595,
    cy: 13.4254,
    r: 1.54872,
    fill: "url(#paint146_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 196.887,
    cy: 13.4254,
    r: 1.54872,
    fill: "url(#paint147_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.18,
    cy: 13.4254,
    r: 1.54872,
    fill: "url(#paint148_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 215.472,
    cy: 13.4254,
    r: 1.54872,
    fill: "url(#paint149_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 224.765,
    cy: 13.4254,
    r: 1.54872,
    fill: "url(#paint150_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.057,
    cy: 13.4254,
    r: 1.54872,
    fill: "url(#paint151_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 187.595,
    cy: 22.7179,
    r: 1.54872,
    fill: "url(#paint152_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 196.887,
    cy: 22.7179,
    r: 1.54872,
    fill: "url(#paint153_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.18,
    cy: 22.7179,
    r: 1.54872,
    fill: "url(#paint154_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 215.472,
    cy: 22.7179,
    r: 1.54872,
    fill: "url(#paint155_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 224.765,
    cy: 22.7179,
    r: 1.54872,
    fill: "url(#paint156_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.057,
    cy: 22.7179,
    r: 1.54872,
    fill: "url(#paint157_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 187.595,
    cy: 32.0104,
    r: 1.54872,
    fill: "url(#paint158_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 196.887,
    cy: 32.0104,
    r: 1.54872,
    fill: "url(#paint159_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.18,
    cy: 32.0104,
    r: 1.54872,
    fill: "url(#paint160_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 215.472,
    cy: 32.0104,
    r: 1.54872,
    fill: "url(#paint161_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 224.765,
    cy: 32.0104,
    r: 1.54872,
    fill: "url(#paint162_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.057,
    cy: 32.0104,
    r: 1.54872,
    fill: "url(#paint163_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 187.595,
    cy: 41.3029,
    r: 1.54872,
    fill: "url(#paint164_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 196.887,
    cy: 41.3029,
    r: 1.54872,
    fill: "url(#paint165_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.18,
    cy: 41.3029,
    r: 1.54872,
    fill: "url(#paint166_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 215.472,
    cy: 41.3029,
    r: 1.54872,
    fill: "url(#paint167_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 224.765,
    cy: 41.3029,
    r: 1.54872,
    fill: "url(#paint168_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.057,
    cy: 41.3029,
    r: 1.54872,
    fill: "url(#paint169_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 187.595,
    cy: 50.5949,
    r: 1.54872,
    fill: "url(#paint170_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 196.887,
    cy: 50.5949,
    r: 1.54872,
    fill: "url(#paint171_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.18,
    cy: 50.5949,
    r: 1.54872,
    fill: "url(#paint172_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 215.472,
    cy: 50.5949,
    r: 1.54872,
    fill: "url(#paint173_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 224.765,
    cy: 50.5949,
    r: 1.54872,
    fill: "url(#paint174_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.057,
    cy: 50.5949,
    r: 1.54872,
    fill: "url(#paint175_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 187.595,
    cy: 59.8873,
    r: 1.54872,
    fill: "url(#paint176_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 196.887,
    cy: 59.8873,
    r: 1.54872,
    fill: "url(#paint177_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.18,
    cy: 59.8873,
    r: 1.54872,
    fill: "url(#paint178_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 215.472,
    cy: 59.8873,
    r: 1.54872,
    fill: "url(#paint179_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 224.765,
    cy: 59.8873,
    r: 1.54872,
    fill: "url(#paint180_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.057,
    cy: 59.8873,
    r: 1.54872,
    fill: "url(#paint181_linear_2683_332862)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 242.549,
    cy: 4.13344,
    r: 1.54872,
    fill: "url(#paint182_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 242.549,
    cy: 13.4254,
    r: 1.54872,
    fill: "url(#paint183_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 242.549,
    cy: 22.7179,
    r: 1.54872,
    fill: "url(#paint184_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 242.549,
    cy: 32.0104,
    r: 1.54872,
    fill: "url(#paint185_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 242.549,
    cy: 41.3029,
    r: 1.54872,
    fill: "url(#paint186_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 242.549,
    cy: 50.5949,
    r: 1.54872,
    fill: "url(#paint187_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 242.549,
    cy: 59.8873,
    r: 1.54872,
    fill: "url(#paint188_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.841,
    cy: 4.13344,
    r: 1.54872,
    fill: "url(#paint189_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.841,
    cy: 13.4254,
    r: 1.54872,
    fill: "url(#paint190_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.841,
    cy: 22.7179,
    r: 1.54872,
    fill: "url(#paint191_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.841,
    cy: 32.0104,
    r: 1.54872,
    fill: "url(#paint192_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.841,
    cy: 41.3029,
    r: 1.54872,
    fill: "url(#paint193_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.841,
    cy: 50.5949,
    r: 1.54872,
    fill: "url(#paint194_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.841,
    cy: 59.8873,
    r: 1.54872,
    fill: "url(#paint195_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 261.134,
    cy: 4.13344,
    r: 1.54872,
    fill: "url(#paint196_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 261.134,
    cy: 13.4254,
    r: 1.54872,
    fill: "url(#paint197_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 261.134,
    cy: 22.7179,
    r: 1.54872,
    fill: "url(#paint198_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 261.134,
    cy: 32.0104,
    r: 1.54872,
    fill: "url(#paint199_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 261.134,
    cy: 41.3029,
    r: 1.54872,
    fill: "url(#paint200_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 261.134,
    cy: 50.5949,
    r: 1.54872,
    fill: "url(#paint201_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 261.134,
    cy: 59.8873,
    r: 1.54872,
    fill: "url(#paint202_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270.426,
    cy: 4.13344,
    r: 1.54872,
    fill: "url(#paint203_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270.426,
    cy: 13.4254,
    r: 1.54872,
    fill: "url(#paint204_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270.426,
    cy: 22.7179,
    r: 1.54872,
    fill: "url(#paint205_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270.426,
    cy: 32.0104,
    r: 1.54872,
    fill: "url(#paint206_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270.426,
    cy: 41.3029,
    r: 1.54872,
    fill: "url(#paint207_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270.426,
    cy: 50.5949,
    r: 1.54872,
    fill: "url(#paint208_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270.426,
    cy: 59.8873,
    r: 1.54872,
    fill: "url(#paint209_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 279.719,
    cy: 4.13344,
    r: 1.54872,
    fill: "url(#paint210_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 279.719,
    cy: 13.4254,
    r: 1.54872,
    fill: "url(#paint211_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 279.719,
    cy: 22.7179,
    r: 1.54872,
    fill: "url(#paint212_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 279.719,
    cy: 32.0104,
    r: 1.54872,
    fill: "url(#paint213_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 279.719,
    cy: 41.3029,
    r: 1.54872,
    fill: "url(#paint214_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 279.719,
    cy: 50.5949,
    r: 1.54872,
    fill: "url(#paint215_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 279.719,
    cy: 59.8873,
    r: 1.54872,
    fill: "url(#paint216_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 289.01,
    cy: 4.13344,
    r: 1.54872,
    fill: "url(#paint217_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 289.01,
    cy: 13.4254,
    r: 1.54872,
    fill: "url(#paint218_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 289.01,
    cy: 22.7179,
    r: 1.54872,
    fill: "url(#paint219_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 289.01,
    cy: 32.0104,
    r: 1.54872,
    fill: "url(#paint220_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 289.01,
    cy: 41.3029,
    r: 1.54872,
    fill: "url(#paint221_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 289.01,
    cy: 50.5949,
    r: 1.54872,
    fill: "url(#paint222_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 289.01,
    cy: 59.8873,
    r: 1.54872,
    fill: "url(#paint223_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 298.302,
    cy: 4.13344,
    r: 1.54872,
    fill: "url(#paint224_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 298.302,
    cy: 13.4254,
    r: 1.54872,
    fill: "url(#paint225_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 298.302,
    cy: 22.7179,
    r: 1.54872,
    fill: "url(#paint226_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 298.302,
    cy: 32.0104,
    r: 1.54872,
    fill: "url(#paint227_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 298.302,
    cy: 41.3029,
    r: 1.54872,
    fill: "url(#paint228_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 298.302,
    cy: 50.5949,
    r: 1.54872,
    fill: "url(#paint229_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 298.302,
    cy: 59.8873,
    r: 1.54872,
    fill: "url(#paint230_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 307.595,
    cy: 4.13344,
    r: 1.54872,
    fill: "url(#paint231_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 307.595,
    cy: 13.4254,
    r: 1.54872,
    fill: "url(#paint232_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 307.595,
    cy: 22.7179,
    r: 1.54872,
    fill: "url(#paint233_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 307.595,
    cy: 32.0104,
    r: 1.54872,
    fill: "url(#paint234_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 307.595,
    cy: 41.3029,
    r: 1.54872,
    fill: "url(#paint235_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 307.595,
    cy: 50.5949,
    r: 1.54872,
    fill: "url(#paint236_linear_2683_332862)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 307.595,
    cy: 59.8873,
    r: 1.54872,
    fill: "url(#paint237_linear_2683_332862)"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -142,
    y: -4,
    width: 213,
    height: 69,
    fill: "url(#paint238_linear_2683_332862)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2683_332862",
    x1: 1.54872,
    y1: 2.58472,
    x2: 1.54872,
    y2: 5.68216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2683_332862",
    x1: 1.54872,
    y1: 11.8767,
    x2: 1.54872,
    y2: 14.9741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2683_332862",
    x1: 1.54872,
    y1: 21.1692,
    x2: 1.54872,
    y2: 24.2666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2683_332862",
    x1: 1.54872,
    y1: 30.4617,
    x2: 1.54872,
    y2: 33.5591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2683_332862",
    x1: 1.54872,
    y1: 39.7542,
    x2: 1.54872,
    y2: 42.8516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2683_332862",
    x1: 1.54872,
    y1: 49.0461,
    x2: 1.54872,
    y2: 52.1436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2683_332862",
    x1: 1.54872,
    y1: 58.3386,
    x2: 1.54872,
    y2: 61.4361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2683_332862",
    x1: 10.8412,
    y1: 2.58472,
    x2: 10.8412,
    y2: 5.68216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2683_332862",
    x1: 10.8412,
    y1: 11.8767,
    x2: 10.8412,
    y2: 14.9741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2683_332862",
    x1: 10.8412,
    y1: 21.1692,
    x2: 10.8412,
    y2: 24.2666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2683_332862",
    x1: 10.8412,
    y1: 30.4617,
    x2: 10.8412,
    y2: 33.5591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2683_332862",
    x1: 10.8412,
    y1: 39.7542,
    x2: 10.8412,
    y2: 42.8516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2683_332862",
    x1: 10.8412,
    y1: 49.0461,
    x2: 10.8412,
    y2: 52.1436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2683_332862",
    x1: 10.8412,
    y1: 58.3386,
    x2: 10.8412,
    y2: 61.4361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2683_332862",
    x1: 20.1336,
    y1: 2.58472,
    x2: 20.1336,
    y2: 5.68216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2683_332862",
    x1: 20.1336,
    y1: 11.8767,
    x2: 20.1336,
    y2: 14.9741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2683_332862",
    x1: 20.1336,
    y1: 21.1692,
    x2: 20.1336,
    y2: 24.2666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2683_332862",
    x1: 20.1336,
    y1: 30.4617,
    x2: 20.1336,
    y2: 33.5591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2683_332862",
    x1: 20.1336,
    y1: 39.7542,
    x2: 20.1336,
    y2: 42.8516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2683_332862",
    x1: 20.1336,
    y1: 49.0461,
    x2: 20.1336,
    y2: 52.1436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2683_332862",
    x1: 20.1336,
    y1: 58.3386,
    x2: 20.1336,
    y2: 61.4361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2683_332862",
    x1: 29.4261,
    y1: 2.58472,
    x2: 29.4261,
    y2: 5.68216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_2683_332862",
    x1: 29.4261,
    y1: 11.8767,
    x2: 29.4261,
    y2: 14.9741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_2683_332862",
    x1: 29.4261,
    y1: 21.1692,
    x2: 29.4261,
    y2: 24.2666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2683_332862",
    x1: 29.4261,
    y1: 30.4617,
    x2: 29.4261,
    y2: 33.5591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2683_332862",
    x1: 29.4261,
    y1: 39.7542,
    x2: 29.4261,
    y2: 42.8516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_2683_332862",
    x1: 29.4261,
    y1: 49.0461,
    x2: 29.4261,
    y2: 52.1436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_2683_332862",
    x1: 29.4261,
    y1: 58.3386,
    x2: 29.4261,
    y2: 61.4361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_2683_332862",
    x1: 38.7185,
    y1: 2.58472,
    x2: 38.7185,
    y2: 5.68216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_2683_332862",
    x1: 38.7185,
    y1: 11.8767,
    x2: 38.7185,
    y2: 14.9741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_2683_332862",
    x1: 38.7185,
    y1: 21.1692,
    x2: 38.7185,
    y2: 24.2666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_2683_332862",
    x1: 38.7185,
    y1: 30.4617,
    x2: 38.7185,
    y2: 33.5591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_2683_332862",
    x1: 38.7185,
    y1: 39.7542,
    x2: 38.7185,
    y2: 42.8516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_2683_332862",
    x1: 38.7185,
    y1: 49.0461,
    x2: 38.7185,
    y2: 52.1436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_2683_332862",
    x1: 38.7185,
    y1: 58.3386,
    x2: 38.7185,
    y2: 61.4361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_2683_332862",
    x1: 48.0099,
    y1: 2.58472,
    x2: 48.0099,
    y2: 5.68216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_2683_332862",
    x1: 48.0099,
    y1: 11.8767,
    x2: 48.0099,
    y2: 14.9741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_2683_332862",
    x1: 48.0099,
    y1: 21.1692,
    x2: 48.0099,
    y2: 24.2666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_2683_332862",
    x1: 48.0099,
    y1: 30.4617,
    x2: 48.0099,
    y2: 33.5591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_2683_332862",
    x1: 48.0099,
    y1: 39.7542,
    x2: 48.0099,
    y2: 42.8516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_2683_332862",
    x1: 48.0099,
    y1: 49.0461,
    x2: 48.0099,
    y2: 52.1436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_2683_332862",
    x1: 48.0099,
    y1: 58.3386,
    x2: 48.0099,
    y2: 61.4361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_2683_332862",
    x1: 57.3023,
    y1: 2.58472,
    x2: 57.3023,
    y2: 5.68216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_2683_332862",
    x1: 57.3023,
    y1: 11.8767,
    x2: 57.3023,
    y2: 14.9741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_2683_332862",
    x1: 57.3023,
    y1: 21.1692,
    x2: 57.3023,
    y2: 24.2666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_2683_332862",
    x1: 57.3023,
    y1: 30.4617,
    x2: 57.3023,
    y2: 33.5591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_2683_332862",
    x1: 57.3023,
    y1: 39.7542,
    x2: 57.3023,
    y2: 42.8516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_2683_332862",
    x1: 57.3023,
    y1: 49.0461,
    x2: 57.3023,
    y2: 52.1436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_2683_332862",
    x1: 57.3023,
    y1: 58.3386,
    x2: 57.3023,
    y2: 61.4361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_2683_332862",
    x1: 66.5948,
    y1: 2.58472,
    x2: 66.5948,
    y2: 5.68216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_2683_332862",
    x1: 75.8873,
    y1: 2.58472,
    x2: 75.8873,
    y2: 5.68216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_2683_332862",
    x1: 85.1797,
    y1: 2.58472,
    x2: 85.1797,
    y2: 5.68216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_2683_332862",
    x1: 94.4722,
    y1: 2.58472,
    x2: 94.4722,
    y2: 5.68216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_2683_332862",
    x1: 103.765,
    y1: 2.58472,
    x2: 103.765,
    y2: 5.68216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_2683_332862",
    x1: 113.057,
    y1: 2.58472,
    x2: 113.057,
    y2: 5.68216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_2683_332862",
    x1: 66.5948,
    y1: 11.8767,
    x2: 66.5948,
    y2: 14.9741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_2683_332862",
    x1: 75.8873,
    y1: 11.8767,
    x2: 75.8873,
    y2: 14.9741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_2683_332862",
    x1: 85.1797,
    y1: 11.8767,
    x2: 85.1797,
    y2: 14.9741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_2683_332862",
    x1: 94.4722,
    y1: 11.8767,
    x2: 94.4722,
    y2: 14.9741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_2683_332862",
    x1: 103.765,
    y1: 11.8767,
    x2: 103.765,
    y2: 14.9741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_2683_332862",
    x1: 113.057,
    y1: 11.8767,
    x2: 113.057,
    y2: 14.9741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_2683_332862",
    x1: 66.5948,
    y1: 21.1692,
    x2: 66.5948,
    y2: 24.2666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_2683_332862",
    x1: 75.8873,
    y1: 21.1692,
    x2: 75.8873,
    y2: 24.2666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_2683_332862",
    x1: 85.1797,
    y1: 21.1692,
    x2: 85.1797,
    y2: 24.2666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_2683_332862",
    x1: 94.4722,
    y1: 21.1692,
    x2: 94.4722,
    y2: 24.2666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_2683_332862",
    x1: 103.765,
    y1: 21.1692,
    x2: 103.765,
    y2: 24.2666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_2683_332862",
    x1: 113.057,
    y1: 21.1692,
    x2: 113.057,
    y2: 24.2666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_2683_332862",
    x1: 66.5948,
    y1: 30.4617,
    x2: 66.5948,
    y2: 33.5591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_2683_332862",
    x1: 75.8873,
    y1: 30.4617,
    x2: 75.8873,
    y2: 33.5591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_2683_332862",
    x1: 85.1797,
    y1: 30.4617,
    x2: 85.1797,
    y2: 33.5591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_2683_332862",
    x1: 94.4722,
    y1: 30.4617,
    x2: 94.4722,
    y2: 33.5591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_2683_332862",
    x1: 103.765,
    y1: 30.4617,
    x2: 103.765,
    y2: 33.5591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_2683_332862",
    x1: 113.057,
    y1: 30.4617,
    x2: 113.057,
    y2: 33.5591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_2683_332862",
    x1: 66.5948,
    y1: 39.7542,
    x2: 66.5948,
    y2: 42.8516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_2683_332862",
    x1: 75.8873,
    y1: 39.7542,
    x2: 75.8873,
    y2: 42.8516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_2683_332862",
    x1: 85.1797,
    y1: 39.7542,
    x2: 85.1797,
    y2: 42.8516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_2683_332862",
    x1: 94.4722,
    y1: 39.7542,
    x2: 94.4722,
    y2: 42.8516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_2683_332862",
    x1: 103.765,
    y1: 39.7542,
    x2: 103.765,
    y2: 42.8516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_2683_332862",
    x1: 113.057,
    y1: 39.7542,
    x2: 113.057,
    y2: 42.8516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_2683_332862",
    x1: 66.5948,
    y1: 49.0461,
    x2: 66.5948,
    y2: 52.1436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_2683_332862",
    x1: 75.8873,
    y1: 49.0461,
    x2: 75.8873,
    y2: 52.1436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_2683_332862",
    x1: 85.1797,
    y1: 49.0461,
    x2: 85.1797,
    y2: 52.1436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_2683_332862",
    x1: 94.4722,
    y1: 49.0461,
    x2: 94.4722,
    y2: 52.1436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_2683_332862",
    x1: 103.765,
    y1: 49.0461,
    x2: 103.765,
    y2: 52.1436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_2683_332862",
    x1: 113.057,
    y1: 49.0461,
    x2: 113.057,
    y2: 52.1436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_2683_332862",
    x1: 66.5948,
    y1: 58.3386,
    x2: 66.5948,
    y2: 61.4361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_2683_332862",
    x1: 75.8873,
    y1: 58.3386,
    x2: 75.8873,
    y2: 61.4361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_2683_332862",
    x1: 85.1797,
    y1: 58.3386,
    x2: 85.1797,
    y2: 61.4361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_2683_332862",
    x1: 94.4722,
    y1: 58.3386,
    x2: 94.4722,
    y2: 61.4361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_2683_332862",
    x1: 103.765,
    y1: 58.3386,
    x2: 103.765,
    y2: 61.4361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_2683_332862",
    x1: 113.057,
    y1: 58.3386,
    x2: 113.057,
    y2: 61.4361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_2683_332862",
    x1: 122.549,
    y1: 2.58472,
    x2: 122.549,
    y2: 5.68216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_2683_332862",
    x1: 122.549,
    y1: 11.8767,
    x2: 122.549,
    y2: 14.9741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_2683_332862",
    x1: 122.549,
    y1: 21.1692,
    x2: 122.549,
    y2: 24.2666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_2683_332862",
    x1: 122.549,
    y1: 30.4617,
    x2: 122.549,
    y2: 33.5591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_2683_332862",
    x1: 122.549,
    y1: 39.7542,
    x2: 122.549,
    y2: 42.8516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_2683_332862",
    x1: 122.549,
    y1: 49.0461,
    x2: 122.549,
    y2: 52.1436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_2683_332862",
    x1: 122.549,
    y1: 58.3386,
    x2: 122.549,
    y2: 61.4361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_2683_332862",
    x1: 131.841,
    y1: 2.58472,
    x2: 131.841,
    y2: 5.68216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_2683_332862",
    x1: 131.841,
    y1: 11.8767,
    x2: 131.841,
    y2: 14.9741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_2683_332862",
    x1: 131.841,
    y1: 21.1692,
    x2: 131.841,
    y2: 24.2666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_2683_332862",
    x1: 131.841,
    y1: 30.4617,
    x2: 131.841,
    y2: 33.5591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_2683_332862",
    x1: 131.841,
    y1: 39.7542,
    x2: 131.841,
    y2: 42.8516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_2683_332862",
    x1: 131.841,
    y1: 49.0461,
    x2: 131.841,
    y2: 52.1436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_2683_332862",
    x1: 131.841,
    y1: 58.3386,
    x2: 131.841,
    y2: 61.4361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_2683_332862",
    x1: 141.134,
    y1: 2.58472,
    x2: 141.134,
    y2: 5.68216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_2683_332862",
    x1: 141.134,
    y1: 11.8767,
    x2: 141.134,
    y2: 14.9741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_2683_332862",
    x1: 141.134,
    y1: 21.1692,
    x2: 141.134,
    y2: 24.2666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_2683_332862",
    x1: 141.134,
    y1: 30.4617,
    x2: 141.134,
    y2: 33.5591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_2683_332862",
    x1: 141.134,
    y1: 39.7542,
    x2: 141.134,
    y2: 42.8516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_2683_332862",
    x1: 141.134,
    y1: 49.0461,
    x2: 141.134,
    y2: 52.1436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_2683_332862",
    x1: 141.134,
    y1: 58.3386,
    x2: 141.134,
    y2: 61.4361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_2683_332862",
    x1: 150.426,
    y1: 2.58472,
    x2: 150.426,
    y2: 5.68216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_2683_332862",
    x1: 150.426,
    y1: 11.8767,
    x2: 150.426,
    y2: 14.9741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_2683_332862",
    x1: 150.426,
    y1: 21.1692,
    x2: 150.426,
    y2: 24.2666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_2683_332862",
    x1: 150.426,
    y1: 30.4617,
    x2: 150.426,
    y2: 33.5591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear_2683_332862",
    x1: 150.426,
    y1: 39.7542,
    x2: 150.426,
    y2: 42.8516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_2683_332862",
    x1: 150.426,
    y1: 49.0461,
    x2: 150.426,
    y2: 52.1436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_2683_332862",
    x1: 150.426,
    y1: 58.3386,
    x2: 150.426,
    y2: 61.4361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear_2683_332862",
    x1: 159.719,
    y1: 2.58472,
    x2: 159.719,
    y2: 5.68216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear_2683_332862",
    x1: 159.719,
    y1: 11.8767,
    x2: 159.719,
    y2: 14.9741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear_2683_332862",
    x1: 159.719,
    y1: 21.1692,
    x2: 159.719,
    y2: 24.2666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear_2683_332862",
    x1: 159.719,
    y1: 30.4617,
    x2: 159.719,
    y2: 33.5591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear_2683_332862",
    x1: 159.719,
    y1: 39.7542,
    x2: 159.719,
    y2: 42.8516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear_2683_332862",
    x1: 159.719,
    y1: 49.0461,
    x2: 159.719,
    y2: 52.1436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear_2683_332862",
    x1: 159.719,
    y1: 58.3386,
    x2: 159.719,
    y2: 61.4361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear_2683_332862",
    x1: 169.01,
    y1: 2.58472,
    x2: 169.01,
    y2: 5.68216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear_2683_332862",
    x1: 169.01,
    y1: 11.8767,
    x2: 169.01,
    y2: 14.9741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint128_linear_2683_332862",
    x1: 169.01,
    y1: 21.1692,
    x2: 169.01,
    y2: 24.2666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint129_linear_2683_332862",
    x1: 169.01,
    y1: 30.4617,
    x2: 169.01,
    y2: 33.5591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint130_linear_2683_332862",
    x1: 169.01,
    y1: 39.7542,
    x2: 169.01,
    y2: 42.8516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint131_linear_2683_332862",
    x1: 169.01,
    y1: 49.0461,
    x2: 169.01,
    y2: 52.1436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint132_linear_2683_332862",
    x1: 169.01,
    y1: 58.3386,
    x2: 169.01,
    y2: 61.4361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint133_linear_2683_332862",
    x1: 178.302,
    y1: 2.58472,
    x2: 178.302,
    y2: 5.68216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint134_linear_2683_332862",
    x1: 178.302,
    y1: 11.8767,
    x2: 178.302,
    y2: 14.9741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint135_linear_2683_332862",
    x1: 178.302,
    y1: 21.1692,
    x2: 178.302,
    y2: 24.2666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint136_linear_2683_332862",
    x1: 178.302,
    y1: 30.4617,
    x2: 178.302,
    y2: 33.5591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint137_linear_2683_332862",
    x1: 178.302,
    y1: 39.7542,
    x2: 178.302,
    y2: 42.8516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint138_linear_2683_332862",
    x1: 178.302,
    y1: 49.0461,
    x2: 178.302,
    y2: 52.1436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint139_linear_2683_332862",
    x1: 178.302,
    y1: 58.3386,
    x2: 178.302,
    y2: 61.4361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint140_linear_2683_332862",
    x1: 187.595,
    y1: 2.58472,
    x2: 187.595,
    y2: 5.68216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint141_linear_2683_332862",
    x1: 196.887,
    y1: 2.58472,
    x2: 196.887,
    y2: 5.68216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint142_linear_2683_332862",
    x1: 206.18,
    y1: 2.58472,
    x2: 206.18,
    y2: 5.68216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint143_linear_2683_332862",
    x1: 215.472,
    y1: 2.58472,
    x2: 215.472,
    y2: 5.68216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint144_linear_2683_332862",
    x1: 224.765,
    y1: 2.58472,
    x2: 224.765,
    y2: 5.68216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint145_linear_2683_332862",
    x1: 234.057,
    y1: 2.58472,
    x2: 234.057,
    y2: 5.68216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint146_linear_2683_332862",
    x1: 187.595,
    y1: 11.8767,
    x2: 187.595,
    y2: 14.9741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint147_linear_2683_332862",
    x1: 196.887,
    y1: 11.8767,
    x2: 196.887,
    y2: 14.9741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint148_linear_2683_332862",
    x1: 206.18,
    y1: 11.8767,
    x2: 206.18,
    y2: 14.9741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint149_linear_2683_332862",
    x1: 215.472,
    y1: 11.8767,
    x2: 215.472,
    y2: 14.9741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint150_linear_2683_332862",
    x1: 224.765,
    y1: 11.8767,
    x2: 224.765,
    y2: 14.9741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint151_linear_2683_332862",
    x1: 234.057,
    y1: 11.8767,
    x2: 234.057,
    y2: 14.9741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint152_linear_2683_332862",
    x1: 187.595,
    y1: 21.1692,
    x2: 187.595,
    y2: 24.2666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint153_linear_2683_332862",
    x1: 196.887,
    y1: 21.1692,
    x2: 196.887,
    y2: 24.2666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint154_linear_2683_332862",
    x1: 206.18,
    y1: 21.1692,
    x2: 206.18,
    y2: 24.2666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint155_linear_2683_332862",
    x1: 215.472,
    y1: 21.1692,
    x2: 215.472,
    y2: 24.2666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint156_linear_2683_332862",
    x1: 224.765,
    y1: 21.1692,
    x2: 224.765,
    y2: 24.2666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint157_linear_2683_332862",
    x1: 234.057,
    y1: 21.1692,
    x2: 234.057,
    y2: 24.2666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint158_linear_2683_332862",
    x1: 187.595,
    y1: 30.4617,
    x2: 187.595,
    y2: 33.5591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint159_linear_2683_332862",
    x1: 196.887,
    y1: 30.4617,
    x2: 196.887,
    y2: 33.5591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint160_linear_2683_332862",
    x1: 206.18,
    y1: 30.4617,
    x2: 206.18,
    y2: 33.5591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint161_linear_2683_332862",
    x1: 215.472,
    y1: 30.4617,
    x2: 215.472,
    y2: 33.5591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint162_linear_2683_332862",
    x1: 224.765,
    y1: 30.4617,
    x2: 224.765,
    y2: 33.5591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint163_linear_2683_332862",
    x1: 234.057,
    y1: 30.4617,
    x2: 234.057,
    y2: 33.5591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint164_linear_2683_332862",
    x1: 187.595,
    y1: 39.7542,
    x2: 187.595,
    y2: 42.8516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint165_linear_2683_332862",
    x1: 196.887,
    y1: 39.7542,
    x2: 196.887,
    y2: 42.8516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint166_linear_2683_332862",
    x1: 206.18,
    y1: 39.7542,
    x2: 206.18,
    y2: 42.8516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint167_linear_2683_332862",
    x1: 215.472,
    y1: 39.7542,
    x2: 215.472,
    y2: 42.8516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint168_linear_2683_332862",
    x1: 224.765,
    y1: 39.7542,
    x2: 224.765,
    y2: 42.8516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint169_linear_2683_332862",
    x1: 234.057,
    y1: 39.7542,
    x2: 234.057,
    y2: 42.8516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint170_linear_2683_332862",
    x1: 187.595,
    y1: 49.0461,
    x2: 187.595,
    y2: 52.1436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint171_linear_2683_332862",
    x1: 196.887,
    y1: 49.0461,
    x2: 196.887,
    y2: 52.1436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint172_linear_2683_332862",
    x1: 206.18,
    y1: 49.0461,
    x2: 206.18,
    y2: 52.1436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint173_linear_2683_332862",
    x1: 215.472,
    y1: 49.0461,
    x2: 215.472,
    y2: 52.1436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint174_linear_2683_332862",
    x1: 224.765,
    y1: 49.0461,
    x2: 224.765,
    y2: 52.1436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint175_linear_2683_332862",
    x1: 234.057,
    y1: 49.0461,
    x2: 234.057,
    y2: 52.1436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint176_linear_2683_332862",
    x1: 187.595,
    y1: 58.3386,
    x2: 187.595,
    y2: 61.4361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint177_linear_2683_332862",
    x1: 196.887,
    y1: 58.3386,
    x2: 196.887,
    y2: 61.4361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint178_linear_2683_332862",
    x1: 206.18,
    y1: 58.3386,
    x2: 206.18,
    y2: 61.4361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint179_linear_2683_332862",
    x1: 215.472,
    y1: 58.3386,
    x2: 215.472,
    y2: 61.4361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint180_linear_2683_332862",
    x1: 224.765,
    y1: 58.3386,
    x2: 224.765,
    y2: 61.4361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint181_linear_2683_332862",
    x1: 234.057,
    y1: 58.3386,
    x2: 234.057,
    y2: 61.4361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint182_linear_2683_332862",
    x1: 242.549,
    y1: 2.58472,
    x2: 242.549,
    y2: 5.68216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint183_linear_2683_332862",
    x1: 242.549,
    y1: 11.8767,
    x2: 242.549,
    y2: 14.9741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint184_linear_2683_332862",
    x1: 242.549,
    y1: 21.1692,
    x2: 242.549,
    y2: 24.2666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint185_linear_2683_332862",
    x1: 242.549,
    y1: 30.4617,
    x2: 242.549,
    y2: 33.5591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint186_linear_2683_332862",
    x1: 242.549,
    y1: 39.7542,
    x2: 242.549,
    y2: 42.8516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint187_linear_2683_332862",
    x1: 242.549,
    y1: 49.0461,
    x2: 242.549,
    y2: 52.1436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint188_linear_2683_332862",
    x1: 242.549,
    y1: 58.3386,
    x2: 242.549,
    y2: 61.4361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint189_linear_2683_332862",
    x1: 251.841,
    y1: 2.58472,
    x2: 251.841,
    y2: 5.68216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint190_linear_2683_332862",
    x1: 251.841,
    y1: 11.8767,
    x2: 251.841,
    y2: 14.9741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint191_linear_2683_332862",
    x1: 251.841,
    y1: 21.1692,
    x2: 251.841,
    y2: 24.2666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint192_linear_2683_332862",
    x1: 251.841,
    y1: 30.4617,
    x2: 251.841,
    y2: 33.5591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint193_linear_2683_332862",
    x1: 251.841,
    y1: 39.7542,
    x2: 251.841,
    y2: 42.8516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint194_linear_2683_332862",
    x1: 251.841,
    y1: 49.0461,
    x2: 251.841,
    y2: 52.1436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint195_linear_2683_332862",
    x1: 251.841,
    y1: 58.3386,
    x2: 251.841,
    y2: 61.4361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint196_linear_2683_332862",
    x1: 261.134,
    y1: 2.58472,
    x2: 261.134,
    y2: 5.68216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint197_linear_2683_332862",
    x1: 261.134,
    y1: 11.8767,
    x2: 261.134,
    y2: 14.9741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint198_linear_2683_332862",
    x1: 261.134,
    y1: 21.1692,
    x2: 261.134,
    y2: 24.2666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint199_linear_2683_332862",
    x1: 261.134,
    y1: 30.4617,
    x2: 261.134,
    y2: 33.5591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint200_linear_2683_332862",
    x1: 261.134,
    y1: 39.7542,
    x2: 261.134,
    y2: 42.8516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint201_linear_2683_332862",
    x1: 261.134,
    y1: 49.0461,
    x2: 261.134,
    y2: 52.1436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint202_linear_2683_332862",
    x1: 261.134,
    y1: 58.3386,
    x2: 261.134,
    y2: 61.4361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint203_linear_2683_332862",
    x1: 270.426,
    y1: 2.58472,
    x2: 270.426,
    y2: 5.68216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint204_linear_2683_332862",
    x1: 270.426,
    y1: 11.8767,
    x2: 270.426,
    y2: 14.9741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint205_linear_2683_332862",
    x1: 270.426,
    y1: 21.1692,
    x2: 270.426,
    y2: 24.2666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint206_linear_2683_332862",
    x1: 270.426,
    y1: 30.4617,
    x2: 270.426,
    y2: 33.5591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint207_linear_2683_332862",
    x1: 270.426,
    y1: 39.7542,
    x2: 270.426,
    y2: 42.8516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint208_linear_2683_332862",
    x1: 270.426,
    y1: 49.0461,
    x2: 270.426,
    y2: 52.1436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint209_linear_2683_332862",
    x1: 270.426,
    y1: 58.3386,
    x2: 270.426,
    y2: 61.4361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint210_linear_2683_332862",
    x1: 279.719,
    y1: 2.58472,
    x2: 279.719,
    y2: 5.68216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint211_linear_2683_332862",
    x1: 279.719,
    y1: 11.8767,
    x2: 279.719,
    y2: 14.9741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint212_linear_2683_332862",
    x1: 279.719,
    y1: 21.1692,
    x2: 279.719,
    y2: 24.2666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint213_linear_2683_332862",
    x1: 279.719,
    y1: 30.4617,
    x2: 279.719,
    y2: 33.5591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint214_linear_2683_332862",
    x1: 279.719,
    y1: 39.7542,
    x2: 279.719,
    y2: 42.8516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint215_linear_2683_332862",
    x1: 279.719,
    y1: 49.0461,
    x2: 279.719,
    y2: 52.1436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint216_linear_2683_332862",
    x1: 279.719,
    y1: 58.3386,
    x2: 279.719,
    y2: 61.4361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint217_linear_2683_332862",
    x1: 289.01,
    y1: 2.58472,
    x2: 289.01,
    y2: 5.68216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint218_linear_2683_332862",
    x1: 289.01,
    y1: 11.8767,
    x2: 289.01,
    y2: 14.9741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint219_linear_2683_332862",
    x1: 289.01,
    y1: 21.1692,
    x2: 289.01,
    y2: 24.2666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint220_linear_2683_332862",
    x1: 289.01,
    y1: 30.4617,
    x2: 289.01,
    y2: 33.5591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint221_linear_2683_332862",
    x1: 289.01,
    y1: 39.7542,
    x2: 289.01,
    y2: 42.8516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint222_linear_2683_332862",
    x1: 289.01,
    y1: 49.0461,
    x2: 289.01,
    y2: 52.1436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint223_linear_2683_332862",
    x1: 289.01,
    y1: 58.3386,
    x2: 289.01,
    y2: 61.4361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint224_linear_2683_332862",
    x1: 298.302,
    y1: 2.58472,
    x2: 298.302,
    y2: 5.68216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint225_linear_2683_332862",
    x1: 298.302,
    y1: 11.8767,
    x2: 298.302,
    y2: 14.9741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint226_linear_2683_332862",
    x1: 298.302,
    y1: 21.1692,
    x2: 298.302,
    y2: 24.2666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint227_linear_2683_332862",
    x1: 298.302,
    y1: 30.4617,
    x2: 298.302,
    y2: 33.5591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint228_linear_2683_332862",
    x1: 298.302,
    y1: 39.7542,
    x2: 298.302,
    y2: 42.8516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint229_linear_2683_332862",
    x1: 298.302,
    y1: 49.0461,
    x2: 298.302,
    y2: 52.1436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint230_linear_2683_332862",
    x1: 298.302,
    y1: 58.3386,
    x2: 298.302,
    y2: 61.4361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint231_linear_2683_332862",
    x1: 307.595,
    y1: 2.58472,
    x2: 307.595,
    y2: 5.68216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint232_linear_2683_332862",
    x1: 307.595,
    y1: 11.8767,
    x2: 307.595,
    y2: 14.9741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint233_linear_2683_332862",
    x1: 307.595,
    y1: 21.1692,
    x2: 307.595,
    y2: 24.2666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint234_linear_2683_332862",
    x1: 307.595,
    y1: 30.4617,
    x2: 307.595,
    y2: 33.5591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint235_linear_2683_332862",
    x1: 307.595,
    y1: 39.7542,
    x2: 307.595,
    y2: 42.8516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint236_linear_2683_332862",
    x1: 307.595,
    y1: 49.0461,
    x2: 307.595,
    y2: 52.1436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint237_linear_2683_332862",
    x1: 307.595,
    y1: 58.3386,
    x2: 307.595,
    y2: 61.4361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F1FA",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#81B9FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614583,
    stopColor: "#BFC9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC9F3",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint238_linear_2683_332862",
    x1: -43.5,
    y1: 31,
    x2: 136,
    y2: 31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.161458,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2683_332862"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 463,
    height: 65,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDottedBgHero);
export default __webpack_public_path__ + "static/media/dottedBgHero.78fd61e5511d5737ec757a997609d4a2.svg";
export { ForwardRef as ReactComponent };